module.exports = __webpack_public_path__ + "assets/media/map-nav.6d9f7dac.svg";